// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__30VH6","footer":"ReportModalFilter_footer__14DRC"};